module.exports = __webpack_public_path__ + "static/media/zs-antoninska.44e1decd.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/sponsors/zs-antoninska.png
// module id = 506
// module chunks = 0